<template>
    <div>
        <b-modal id="modal-Bonus" size="lg" class="modal-form" title="Bonus Agent" @hidden="CLEAR_FORM()" centered hide-footer>
            <div class="form-group">
                <label>Agent Name</label>
                <v-select @input="_getSelectedBonusAgent()" :clearable="false" label="name" :reduce="user_agent => user_agent" v-model="formbonus.user_id" :options="user_agent">
                    <template v-slot:option="option">
                        {{ option.name }} - {{option.email}}
                    </template>
                    <template #selected-option="option">
                        {{ option.name }} - {{option.email}}
                    </template>
                
                </v-select>
            </div>
            
            <div class="col-12 text-center mt-3" v-if="loading_bonus === true">
                <div class="half-circle-spinner">
                    <div class="circle circle-1"></div>
                    <div class="circle circle-2"></div>
                </div>
            </div>

            <template v-if="loading_bonus === false">
                <div class="border-top pt-3" v-if="formbonus.user_id">
                    <h6 class="mb-3">Agent Infomation</h6>
                    <b-row class="mb-4">
                        <b-col md="7">
                            <div class="pb-1"><strong>Name :</strong> {{formbonus.user_id.name}}</div>
                            <div class="pt-1 pb-1"><strong>Email :</strong> {{formbonus.user_id.email}}</div>
                            
                        </b-col>
                        <b-col md="5">
                                <div class="pb-1"><strong>Tier :</strong> {{formbonus.user_id.tier}}</div>
                            <div class="pb-1"><strong>Total Events :</strong> {{formbonus.user_id.events_count}} Event</div>
                        </b-col>
                    </b-row>
                </div>
                <div class="table-responsive bdr-15 mt-3 position-relative">
                    <div class="loading-table d-flex align-items-center justify-content-center" v-if="loading_claim">
                            <div class="half-circle-spinner">
                                <div class="circle circle-1"></div>
                                <div class="circle circle-2"></div>
                            </div>
                    </div>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Event Total</th>
                                <th>Tier</th>
                                <th>Reward</th>
                                <th>Claim Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="data in selected_bonus_agent" :key="data.id">
                                <td>{{data.slot}} Events</td>
                                <td>{{data.tier}}</td>
                                <td>{{data.bonus | formatRupiah}}</td>
                                <td>
                                    <template v-if="data.claim.length === 0">
                                        <div class="d-flex align-items-center">
                                            <datetime zone='local' v-model="data.claim_date" value-zone='local' type="date" input-class="form-control"></datetime>
                                            <button class="ml-3 btn btn-info" v-if="data.claim_date"
                                                :disabled="loading_claim"
                                                :class="loading_claim ? 'btn-progress' : ''"
                                                @click.prevent="_claimBonusAgent(data)"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </template>
                                    <template v-if="data.claim.length !== 0">{{data.claim[0].claim_date | formatDate}}</template>
                                </td>
                                <td>
                                    <!-- <label style="width:80px;" disabled v-if="data.claim.length !== 0 && data.claim[0].status === 'CLAIMED'" class="badge badge-success">CLAIMED</label>
                                    <label style="width:80px;" disabled v-if="data.claim.length === 0 && leaderboard.events_count >= $options.filters.countIndex(index,bonus_agent)" class="badge badge-secondary">LOST</label>
                                    <a target="_blank" v-if="data.claim.length === 0 && leaderboard.events_count >= data.slot && leaderboard.events_count <= $options.filters.countIndex(index,bonus_agent)" :href="'https://wa.me/6281337589348?text=Halo, saya mau claim bonus ' + data.slot + ' Undangan'" class="btn btn-info">CLAIM NOW</a>
                                    <button disabled v-if="data.claim.length === 0 && leaderboard.events_count <= data.slot" class="btn btn-disabled">add {{data.slot - leaderboard.events_count}} events to claim</button> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import vSelect from 'vue-select'
    import { Datetime } from 'vue-datetime';
    import moment from 'moment'

    export default{
        data(){
            return{
                loading:false,
                loading_bonus:false,
                loading_claim:false,
                modal_title : 'Add Bonus',
                agent_info:{},
            }
        },
        components:{
            vSelect,
            Datetime
        },
        props: ['del_bonus'],
        computed: {
            ...mapState('BonusControl', {
                formbonus: state => state.formbonus,
                errors: state => state.errors,
                user_agent: state => state.user_agent,
                selected_bonus_agent: state => state.selected_bonus_agent
            }),
        },
        filters:{
            formatDate: function(val){
                return moment(String(val)).format('DD MMMM YYYY')
            },
            formatRupiah:function(val){
                if(val){
                    let value = (parseInt(val)/1).toFixed(0).replace('.', ',')
                    return "Rp " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }else{
                    return '-'
                }
            }
        },
        methods: {
            ...mapActions('BonusControl', ['createBonus','updateBonus','getSelectedBonusAgent','claimBonusAgent']),
            ...mapMutations('BonusControl', ['CLEAR_FORM']),
            
            _getSelectedBonusAgent:function(){
                this.loading_bonus = true
                this.getSelectedBonusAgent(this.formbonus.user_id.id).then(() => {
                    this.loading_bonus = false
                }).catch((error) => {
                    console.log(error)
                    this.loading_bonus = false
                })
            },
            _claimBonusAgent:function(data){
                this.loading_claim = true
                this.claimBonusAgent(data).then(() => {
                    this.getSelectedBonusAgent(this.formbonus.user_id.id).then(() => {
                        this.loading_claim = false
                    })
                    this.$emit('getBonus');
                }).catch((error) => {
                    console.log(error)
                    this.loading_claim = false
                })
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('name', this.formdata.name);
                        formData.append('email', this.formdata.email ? this.formdata.email : '');
                        formData.append('phone', this.formdata.phone ? this.formdata.phone : '');
                        formData.append('address', this.formdata.address ? this.formdata.address : '');
                        formData.append('sosmed_link', this.formdata.sosmed_link ? this.formdata.sosmed_link : '');
                        formData.append('photo', this.formdata.photo ? this.formdata.photo : '');
                        formData.append('photo_file', this.photo_file);
                        
                        if(id){

                            formData.append("_method", "put");
                            this.updateBonus(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Bonus')
                                this.$emit('getBonus');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Update Bonus')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })

                        }else{

                            this.createBonus(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Bonus')
                                this.$emit('getBonus');
                                this.CLEAR_FORM()
                                this.$toast.success('Successfully Added Bonus')
                            }).catch((error) => {
                                console.log(error)
                                this.loading = false
                                this.$toast.warning('Sorry, Something Error')
                            })
                        }
                    }
                });
            },
        }
    }
</script>
